export default __webpack_public_path__ + "static/media/inner-automated-material-flow.28747768.svg";